import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import BookConsultModal from '../components/BookConsultModal';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Calendar, Phone, Mail, MapPin, Clock } from 'lucide-react';

const ContactPage = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-gradient-to-br from-blue-50 via-cyan-50 to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">Contact Us</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Have questions? We're here to help. Reach out and we'll respond within 1 business day.
          </p>
        </div>
      </section>

      {/* Contact Options */}
      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-8">
            {/* Contact Info */}
            <div className="space-y-6">
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Get in Touch</h2>
              
              <Card className="border-2 border-gray-200">
                <CardContent className="pt-6">
                  <a href="tel:+17746447101" className="flex items-center space-x-4 text-gray-700 hover:text-blue-600 transition-colors">
                    <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                      <Phone className="w-6 h-6 text-blue-600" />
                    </div>
                    <div>
                      <p className="font-semibold">Phone</p>
                      <p className="text-lg">774-644-7101</p>
                    </div>
                  </a>
                </CardContent>
              </Card>

              <Card className="border-2 border-gray-200">
                <CardContent className="pt-6">
                  <a href="mailto:info@microsystemsnetworking.com" className="flex items-center space-x-4 text-gray-700 hover:text-blue-600 transition-colors">
                    <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                      <Mail className="w-6 h-6 text-blue-600" />
                    </div>
                    <div>
                      <p className="font-semibold">Email</p>
                      <p className="text-lg">info@microsystemsnetworking.com</p>
                    </div>
                  </a>
                </CardContent>
              </Card>

              <Card className="border-2 border-gray-200">
                <CardContent className="pt-6">
                  <div className="flex items-center space-x-4 text-gray-700">
                    <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                      <MapPin className="w-6 h-6 text-blue-600" />
                    </div>
                    <div>
                      <p className="font-semibold">Service Area</p>
                      <p className="text-lg">South Shore & Greater Boston, MA</p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-2 border-gray-200">
                <CardContent className="pt-6">
                  <div className="flex items-center space-x-4 text-gray-700">
                    <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                      <Clock className="w-6 h-6 text-blue-600" />
                    </div>
                    <div>
                      <p className="font-semibold">Response Time</p>
                      <p className="text-lg">Within 1 business day</p>
                      <p className="text-sm text-gray-500">Emergency support available 24/7</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* Book Consult CTA */}
            <div className="bg-gradient-to-br from-blue-600 via-blue-700 to-cyan-600 rounded-2xl p-8 text-white flex flex-col justify-center">
              <h3 className="text-3xl font-bold mb-4">Book a Free Consultation</h3>
              <p className="text-blue-100 mb-8 text-lg">
                The best way to get started is with a free consultation. We'll discuss your current IT setup, challenges, and how we can help.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-center">
                  <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center mr-3">
                    <span className="text-white text-sm">✓</span>
                  </div>
                  No obligation, no pressure
                </li>
                <li className="flex items-center">
                  <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center mr-3">
                    <span className="text-white text-sm">✓</span>
                  </div>
                  30-minute call or video chat
                </li>
                <li className="flex items-center">
                  <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center mr-3">
                    <span className="text-white text-sm">✓</span>
                  </div>
                  Get answers to your IT questions
                </li>
              </ul>
              <Button 
                size="lg" 
                className="bg-white text-blue-600 hover:bg-gray-100 w-full"
                onClick={() => setShowModal(true)}
                data-testid="contact-page-consult"
              >
                <Calendar className="w-5 h-5 mr-2" />
                Book a Free Consult
              </Button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <BookConsultModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </div>
  );
};

export default ContactPage;
